import { render, staticRenderFns } from "./Voll360.vue?vue&type=template&id=b2928028&scoped=true&"
import script from "./Voll360.vue?vue&type=script&lang=js&"
export * from "./Voll360.vue?vue&type=script&lang=js&"
import style0 from "./Voll360.vue?vue&type=style&index=0&id=b2928028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2928028",
  null
  
)

export default component.exports